import PropTypes from 'prop-types'

export const BusinessReviewPropType = PropTypes.shape({
  location: PropTypes.string,
  date: PropTypes.any,
  source: PropTypes.string,
  score: PropTypes.number,
  price: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
  content: PropTypes.string,
})
